import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import { Row, Col, Card, Button } from 'antd';
import DefaultTemplateContainer from '../../containers/DefaultTemplateContainer'
import {
    getStudentList,
    addStudBirthday
} from '../../actions'
import {
    openModal
} from '../../actions'
class DoshboardBox extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            flash_msg: []
        };
    }

    componentDidMount() {
    }

    render() {
        return (
            <DefaultTemplateContainer
                htmlBody={this.indexButtion()}
            />
        )
    }

    indexButtion() {
        const loginButtion = () => {
            return (

                <Link to='/login'>
                    <Button size='large' style={{ width: '100%' }}>
                        系統登入
                    </Button>
                </Link>
            )
        }
        return (
            <Row>
                <Col span={24}>
                    <Card
                        bordered={false}
                        style={{ width: '100%', height: '100%' }}
                    >
                        <Link to='/login'>
                            <img alt="example" src="/images/qust-115.jpg" style={{ width: '100%', height: '100%' }} />
                        </Link>
                    </Card>
                    {/*{withinButtion()}*/}
                    {/*{newOutsideButtion()}*/}
                    {loginButtion()}
                    {/*{transferOutsideButtion()}*/}
                </Col>
            </Row>
        )
    }


}


const mapStateToProps = (state) => {
    return {
        studentList: state.getIn(['studentList', 'data']),
    }
}
const mapDispatchToProps = (dispatch) => ({
    reLoad: () => (
        dispatch(getStudentList())
    ),
    getStudBirthday: (studentList) => () => (
        dispatch(addStudBirthday(studentList))
    ),
    openModal: () => (
        dispatch(openModal())
    )
});


export default connect(mapStateToProps, mapDispatchToProps)(DoshboardBox)



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/DashboardContainer/DashboardContainer.jsx